import { Badge, alpha, useComputedColorScheme, useMantineTheme } from "@mantine/core";
import SentimentNeutralRounded from "@mui/icons-material/SentimentNeutralRounded";
import SentimentVeryDissatisfiedRounded from "@mui/icons-material/SentimentVeryDissatisfiedRounded";
import SentimentVerySatisfiedRounded from "@mui/icons-material/SentimentVerySatisfiedRounded";
import { QuestionDifficulty } from "enums/contentTypes";
import classes from "./QuestionDifficultyChip.module.css";

export default function QuestionDifficultyChip({
  difficulty,
}: {
  difficulty: QuestionDifficulty;
}) {
  const theme = useMantineTheme();
  const scheme = useComputedColorScheme("light");
  const icon = getQuestionDifficultyIcon(difficulty, 18);
  const color =
    difficulty === "Easy"
      ? ("correct" as const)
      : difficulty === "Medium"
      ? ("darkblue" as const)
      : ("incorrect" as const);
  const shade = difficulty === "Medium" ? 4 : 5;
  const borderOpacity = scheme === "dark" ? 0.58 : 0.38;
  const borderColor = alpha(theme.colors[color][shade], borderOpacity);

  return (
    <Badge
      variant="outline"
      color={color}
      size="md"
      radius="md"
      styles={{
        root: {
          minHeight: 28,
          alignItems: "center",
          borderColor,
        },
      }}
      classNames={{
        root: classes.root,
        label: classes.labelWrap,
      }}
      leftSection={<span className={classes.iconSlot}>{icon}</span>}
    >
      {difficulty}
    </Badge>
  );
}

export function getQuestionDifficultyIcon(
  difficulty: QuestionDifficulty,
  size: number
): JSX.Element {
  const iconProps = {
    style: {
      width: size,
      height: size,
    },
  };
  switch (difficulty) {
    case "Easy":
      return <SentimentVerySatisfiedRounded {...iconProps} />;
    case "Medium":
      return <SentimentNeutralRounded {...iconProps} />;
    case "Hard":
      return <SentimentVeryDissatisfiedRounded {...iconProps} />;
  }
}
